import React from 'react';
import './style.scss';

const Divider = ({ className }) => {
  return (
    <div className={`Divider ${className || ''}`} />
  );
};

export default Divider;
